import { IElbSubscription } from '../model/elb-subscription.model';
import { IPlan, PlanInterval } from '../model/plan.model';
import { IPlanRule } from '../model/plan-rule.model';
import { ISubscriptionItem } from '../model/subscription-item.model';


export function getPlanRules() {
  const planRules: IPlanRule[] = [];
  planRules.push(getSuitePlanRule());
  planRules.push(getTTAPlanRule());
  planRules.push(getCVRPlanRule());
  planRules.push(getARCPlanRule());

  return planRules;

}

export function getSuitePlanRule() {
  const suitePlanRule: IPlanRule = {
    type: 'suite',
    max: 2,
    allowMultiple: true,
    excludingList: ['silver']
  };

  return suitePlanRule;
}

export function getTTAPlanRule() {
  const ttaPlanRule: IPlanRule = {
    type: 'tta',
    max: 1,
    allowMultiple: false,
    excludingList: []
  };

  return ttaPlanRule;
}

export function getCVRPlanRule() {
  const cvrPlanRule: IPlanRule = {
    type: 'cvr',
    max: 1,
    allowMultiple: false,
    excludingList: []
  };

  return cvrPlanRule;
}

export function getARCPlanRule() {
  const arcPlanRule: IPlanRule = {
    type: 'arc',
    max: 1,
    allowMultiple: false,
    excludingList: []
  };

  return arcPlanRule;
}

export function applyPlanRule(planRule: IPlanRule, availableNicnames, selecteNicknames) {
  if (!planRule.allowMultiple) {
    if (selecteNicknames && selecteNicknames.length) {
      const hasIt = selecteNicknames.find((s) => s.includes(planRule.type));
      if (hasIt) {
        return availableNicnames.filter((name) => name.toLowerCase().indexOf(planRule.type) === -1);
      }
    }

  } else {
    let returnArray = availableNicnames;
    const count = selecteNicknames.filter((name) => name.toLowerCase().indexOf(planRule.type) > -1).length;
    if (count >= planRule.max) {
      returnArray = availableNicnames.filter((name) => name.toLowerCase().indexOf(planRule.type) === -1);
    }

    if (planRule.excludingList && planRule.excludingList.length) {
      planRule.excludingList.forEach((exclude) => {
        returnArray = returnArray.filter((name) => name.toLowerCase().indexOf(exclude) === -1);
      });
    }
    return returnArray;
  }

  return availableNicnames;
}

export function applyPlanRules(availableNicnames, selecteNicknames) {
  const rules = getPlanRules();
  let updatedNames = availableNicnames;

  rules.forEach((rule) => {
    updatedNames = applyPlanRule(rule, updatedNames, selecteNicknames);
  });
  return updatedNames;
}

export function  hasTTA(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('_tta')) ? true : false;
}

export function  hasTTANickname(nicknames) {
  return nicknames.find((n) => n.includes('_tta')) ? true : false;
}

export function  hasARC(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('elb_arc')) ? true : false;
}

export function  hasARCNickname(nicknames) {
  return nicknames.find((n) => n.includes('elb_arc')) ? true : false;
}

export function  hasCVR(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('_cvr')) ? true : false;
}

export function  hasCVRNickname(nicknames) {
  return nicknames.find((n) => n.includes('_cvr')) ? true : false;
}

export function  hasLO(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('elb_lo')) ? true : false;
}

export function  hasLONickname(nicknames) {
  return nicknames.find((n) => n.includes('_lo')) ? true : false;
}

export function  hasAL(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('elb_al')) ? true : false;
}

export function  hasALNickname(nicknames) {
  return nicknames.find((n) => n.includes('_al_')) ? true : false;
}

export function  hasREH(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('elb_reh')) ? true : false;
}

export function  hasREHNickname(nicknames) {
  return nicknames.find((n) => n.includes('_reh')) ? true : false;
}

export function  hasBLO(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('elb_blo')) ? true : false;
}

export function  hasBLONickname(nicknames) {
  return nicknames.find((n) => n.includes('_blo')) ? true : false;
}

export function  hasSuite(subscriptions: IElbSubscription[]) {
  return subscriptions.find((s) => s.plan.nickname.includes('suite')) ? true : false;
}

export function  hasSuiteNickname(nicknames) {
  return nicknames.find((n) => n.includes('suite')) ? true : false;
}

export function getAvailablePlansNicknames(subscriptions: IElbSubscription[]) {
  const selected = subscriptions.map((s) => s.plan.nickname);
  let nicknames = getPlanNicknamesFromExistingAllExcluding(subscriptions);

  if (!hasTTA(subscriptions) && !hasTTANickname(nicknames)) {
    nicknames.push(...getAllTTAPlansNickname());
  }

  if (!hasCVR(subscriptions) && !hasCVRNickname(nicknames)) {
    nicknames.push(...getAllCVRPlansNickname());
  }

  if (!hasLO(subscriptions) && !hasLONickname(nicknames)) {
    nicknames.push(...getAllLOPlansNickname());
  }

  if (!hasAL(subscriptions) && !hasALNickname(nicknames)) {
    nicknames.push(...getAllALPlansNickname());
  }

  if (!hasREH(subscriptions) && !hasREHNickname(nicknames)) {
    nicknames.push(...getAllREHPlansNickname());
  }

  if (!hasBLO(subscriptions) && !hasBLONickname(nicknames)) {
    nicknames.push(...getAllBLOPlansNickname());
  }

  if (!hasSuite(subscriptions) && !hasSuiteNickname(nicknames)) {
    nicknames.push(...getAllPlansNickname());
  }

  if (!hasARC(subscriptions) && !hasARCNickname(nicknames)) {
    nicknames.push(...getAllArcadesPlansNickname());
  }

  nicknames = applyPlanRules(nicknames, selected);

  return nicknames;
}

export function getPlanNicknamesFromExisting(nickname: string) {
  if (nickname.includes('_gov')) {
    return getAllGovPlansNickname();
  } else if (nickname.includes('_edu')) {
    return getAllEduPlansNickname();
  } else if (nickname.includes('_k12')) {
    return getAllK12PlansNickname();
  } else if (nickname === 'elb_platinum_suite' || nickname === 'elb_gold_suite' || nickname === 'elb_silver_suite') {
    return getResellerPlansNickname();
  } else if (nickname.includes('_tta')) {
    return getAllTTAPlansNickname();
  } else if (nickname.includes('_cvr')) {
    return getAllCVRPlansNickname();
  } else if (nickname.includes('_lo')) {
    return getAllLOPlansNickname();
  } else if (nickname.includes('elb_al')) {
    return getAllALPlansNickname();
  } else if (nickname.includes('_reh')) {
    return getAllREHPlansNickname();
  } else if (nickname.includes('elb_blo')) {
    return getAllBLOPlansNickname();
  } else if (nickname.includes('elb_arc')) {
    return getAllArcadesPlansNickname();
  }
  return getAllPlansNickname();
}

export function isSilverAllowed(plan: IPlan) {
  if (plan) {
    return !plan.nickname.includes('suite');
  }

  return true;
}

export function isOtherSuiteAllowed(plan: IPlan) {
  return !plan.nickname.includes('silver');
}

export function removeSilverPlans(plans: any) {
  return plans.filter((plan) => !plan['header'] && plan.nickname.indexOf('silver') === -1);
}

export function removeAllSimilar(plans: any, currentPlan: IPlan) {
  if (currentPlan) {
    const isPlatinum = currentPlan.nickname.includes('platinum');
    const isGold = currentPlan.nickname.includes('gold');

    if (isPlatinum) {
      plans =  plans.filter((plan) => !plan['header'] && plan.nickname.indexOf('platinum') === -1);
    }

    if (isGold) {
      plans =  plans.filter((plan) => !plan['header'] && plan.nickname.indexOf('gold') === -1);
    }

  }

  if (!Array.isArray(plans)) {
    return [plans];
  }

  return plans;
}

export function groupPlansForSameTerm(plans: IPlan[], currentPlan: IPlan) {
  let groupedPlans = [];
  const allowSilver = isSilverAllowed(currentPlan);
  if (currentPlan &&  currentPlan.interval === PlanInterval.YEAR) {
    // let suite = getSuites(plans);
    const type = getPlanTypeFromExisting(currentPlan.nickname);
    if (type) {
      if (type === '_gov') {
        groupedPlans.push(...getSuitesGov(plans));
      } else if (type === '_edu'){
        groupedPlans.push(...getSuitesEdu(plans));
      } else if (type === '_k12'){
        groupedPlans.push(...getSuitesK12(plans));
      }
    } else {
      groupedPlans.push(...getSuites(plans));
    }
  } else {
    const suiteMnt = getSuitesMonth(plans);

    if (suiteMnt && suiteMnt.length > 0)  {
      groupedPlans.push(...suiteMnt);
    }
  }

  if (!allowSilver) {
    groupedPlans = removeSilverPlans(groupedPlans);
  }

  groupedPlans = removeAllSimilar(groupedPlans, currentPlan);
  return groupedPlans;
}

export function getRelatedPlans(subscriptionItems: ISubscriptionItem[], plans: IPlan[]) {
  if (subscriptionItems && subscriptionItems.length) {
    const results = [];
    for (const key in subscriptionItems) {
      if (subscriptionItems[key].relatedPlans) {
        // let relatedPlans = subscriptionItems[key].relatedPlans || subscriptionItems[key].elbSubscription.plan.relatedPlans;
        subscriptionItems[key].relatedPlans.split('|').forEach((p) => {
          const plan = plans.find((plan) => plan.nickname === p);
          if (plan && results.indexOf(plan) === -1 &&
          !subscriptionItems.find((s) => s.planNickname === plan.nickname) &&
          plan.interval.toLowerCase() === subscriptionItems[key].interval.toLowerCase()) {
            results.push(plan);
          }
        });
      }
    }

    return results;
  }

  return [];
}

export function groupStudioPlans(plans: IPlan[]) {
  const groupedPlans = [];
  const tta = getTTAPlans(plans);
  const cvr = getCVRPlans(plans);
  const reh = getREHPlans(plans);
  const arc = getArcadesPlans(plans);
  const blo = getBLOPlans(plans);
  const gold = getGoldPlans(plans);

  if (tta && tta.length > 0) {
    groupedPlans.push({ header: 'Games' });
    groupedPlans.push(...tta);
  }

  if (arc && arc.length > 0) {
    groupedPlans.push({ header: 'Arcades' });
    groupedPlans.push(...arc);
  }

  if (cvr && cvr.length > 0) {
    groupedPlans.push({ header: 'CenarioVR®' });
    groupedPlans.push(...cvr);
  }

  if (reh && reh.length > 0) {
    groupedPlans.push({ header: 'Rehearsal' });
    groupedPlans.push(...reh);
  }

  if (blo && blo.length > 0) {
    groupedPlans.push({ header: 'MicroBuilder' });
    groupedPlans.push(...blo);
  }

  if (gold && gold.length > 0) {
    groupedPlans.push({ header: 'Gold' });
    groupedPlans.push(...gold);
  }

  return groupedPlans;
}


export function groupPlans(plans: IPlan[]) {
  const groupedPlans = [];
  const suite = getSuites(plans);
  const suiteMnt = getSuitesMonth(plans);
  const suiteGov = getSuitesGov(plans);
  const suiteEdu = getSuitesEdu(plans);
  const suiteK12 = getSuitesK12(plans);
  const suiteTrial = getSuitesTrial(plans);
  const tta = getTTAPlans(plans);
  const cvr = getCVRPlans(plans);
  const lo = getLOPlans(plans);
  const al = getALPlans(plans);
  const reh = getREHPlans(plans);
  const blo = getBLOPlans(plans);
  const arc = getArcadesPlans(plans);
  const ungrouped = getNonSuitePlans(plans);

  if (suite && suite.length > 0)  {
    groupedPlans.push({ header: 'Suites' });
    groupedPlans.push(...suite);

    if (suiteMnt && suiteMnt.length > 0)  {
      groupedPlans.push(...suiteMnt);
    }
  }

  if (suiteGov && suiteGov.length > 0)  {
    groupedPlans.push({ header: 'Gov Suites' });
    groupedPlans.push(...suiteGov);
  }

  if (suiteEdu && suiteEdu.length > 0)  {
    groupedPlans.push({ header: 'Edu Suites' });
    groupedPlans.push(...suiteEdu);
  }

  if (suiteK12 && suiteK12.length > 0)  {
    groupedPlans.push({ header: 'K12 Suites' });
    groupedPlans.push(...suiteK12);
  }

  if (suiteTrial && suiteTrial.length > 0)  {
    groupedPlans.push({ header: 'Trial Suites' });
    groupedPlans.push(...suiteTrial);
  }

  if (tta && tta.length > 0) {
    groupedPlans.push({ header: 'Games' });
    groupedPlans.push(...tta);
  }

  if (arc && arc.length > 0) {
    groupedPlans.push({ header: 'Arcades' });
    groupedPlans.push(...arc);
  }

  if (cvr && cvr.length > 0) {
    groupedPlans.push({ header: 'CenarioVR®' });
    groupedPlans.push(...cvr);
  }

  if (lo && lo.length > 0) {
    groupedPlans.push({ header: 'Lectora® Online' });
    groupedPlans.push(...lo);
  }

  if (al && al.length > 0) {
    groupedPlans.push({ header: 'Asset Library' });
    groupedPlans.push(...al);
  }

  if (reh && reh.length > 0) {
    groupedPlans.push({ header: 'Rehearsal' });
    groupedPlans.push(...reh);
  }

  if (blo && blo.length > 0) {
    groupedPlans.push({ header: 'MicroBuilder' });
    groupedPlans.push(...blo);
  }


  if (ungrouped && ungrouped.length > 0) {

    groupedPlans.push({ header: 'Others' });
    groupedPlans.push(...ungrouped);
  }

  return groupedPlans;
}

export function groupPlansNoTrial(plans: IPlan[]) {
  const groupedPlans = [];
  groupedPlans.push({ header: 'Suites' });
  groupedPlans.push(...getSuites(plans));
  groupedPlans.push(...getSuitesMonth(plans));
  groupedPlans.push({ header: 'Gov Suites' });
  groupedPlans.push(...getSuitesGov(plans));
  groupedPlans.push({ header: 'Edu Suites' });
  groupedPlans.push(...getSuitesEdu(plans));
  groupedPlans.push({ header: 'K12 Suites' });
  groupedPlans.push(...getSuitesK12(plans));
  return groupedPlans;
}

export function getGoldPlans(plans: IPlan[]) {
  const gold = getAllGoldPlansNickname();

  return plans.filter((plan) => gold.includes(plan.nickname));
}

export function getNonSuitePlans(plans: IPlan[]) {
  return plans.filter((plan) => !plan['header'] && plan.nickname.indexOf('suite') === -1);
}

export function getNonTTAPlans(plans: IPlan[]) {
  return plans.filter((plan) => !plan['header'] && plan.nickname.indexOf('_tta') === -1);
}

export function getTTAPlans(plans: IPlan[]) {
  const tta = getAllTTAPlansNickname();

  return plans.filter((plan) => tta.includes(plan.nickname));
}

export function getCVRPlans(plans: IPlan[]) {
  const cvr = getAllCVRPlansNickname();

  return plans.filter((plan) => cvr.includes(plan.nickname));
}

export function getArcadesPlans(plans: IPlan[]) {
  const arc  = getAllArcadesPlansNickname();

  return plans.filter((plan) => arc.includes(plan.nickname));
}

export function getLOPlans(plans: IPlan[]) {
  const lo = getAllLOPlansNickname();

  return plans.filter((plan) => lo.includes(plan.nickname));
}

export function getALPlans(plans: IPlan[]) {
  const al = getAllALPlansNickname();

  return plans.filter((plan) => al.includes(plan.nickname));
}

export function getREHPlans(plans: IPlan[]) {
  const reh = getAllREHPlansNickname();

  return plans.filter((plan) => reh.includes(plan.nickname));
}

export function getBLOPlans(plans: IPlan[]) {
  const blo = getAllBLOPlansNickname();

  return plans.filter((plan) => blo.includes(plan.nickname));
}


export function getSuites(plans: IPlan[]) {
  const suites = getResellerPlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getSuitesMonth(plans: IPlan[]) {
  const suites = getAllMothtlyPlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getSuitesGov(plans: IPlan[]) {
  const suites = getAllGovPlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getSuitesEdu(plans: IPlan[]) {
  const suites = getAllEduPlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getSuitesK12(plans: IPlan[]) {
  const suites = getAllK12PlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getSuitesTrial(plans: IPlan[]) {
  const suites = getAllTrialPlansNickname();

  return plans.filter((plan) => suites.includes(plan.nickname));
}

export function getPlanTypeFromExisting(nickname: string) {
  if (nickname) {
    if (nickname.includes('_gov')) {
      return '_gov';
    } else if (nickname.includes('_edu')) {
      return '_edu';
    } else if (nickname.includes('_k12')) {
      return '_k12';
    }
  }

  return null;
}

export function getPlanNicknamesFromExistingExcluding(nickname: string) {
  const all = getPlanNicknamesFromExisting(nickname);
  return all.filter((n) => n !== nickname);
}


export function getCheckoutPlanOptionFromNickname(nickname: string, plans: any) {
  const type = getPlanTypeFromExisting(nickname);
  const newPlan = new Set();

  for (const key in plans) {
    if(plans[key].priceId.includes('users_addon')) {
      newPlan.add(plans[key]);
      continue;
    }

    if (type) {
      if (plans[key].priceId.includes(type)) {
        newPlan.add(plans[key]);
      }
    } else {
      if (!plans[key].priceId.includes('_gov') && !plans[key].priceId.includes('_edu') && !plans[key].priceId.includes('_k12')) {
        newPlan.add(plans[key]);
      }
    }
  }
  return Array.from(newPlan);
}


export function getPlanNicknamesFromExistingAllExcluding(subscriptions: IElbSubscription[]) {
  const set = new Set();
  subscriptions.forEach((subscription) => {
    getPlanNicknamesFromExistingExcluding(subscription.plan.nickname).forEach(set.add, set);
  });
  return Array.from(set);
}


export function excludeSilver(arr: any) {
  const silverArr = getAllSilver();
  return arr.filter((n) => !silverArr.includes(n) );
}

export function excludeOtherTTA(arr: any) {

}

export function getAllPlansNickname() {
  const arr = [];
  arr.push(...getResellerPlansNickname());
  arr.push(...getAllMothtlyPlansNickname());
  arr.push(...getAllGovPlansNickname());
  arr.push(...getAllEduPlansNickname());
  arr.push(...getAllK12PlansNickname());
  arr.push(...getAllTrialPlansNickname());
  arr.push(...getAllTTAPlansNickname());
  arr.push(...getAllCVRPlansNickname());
  arr.push(...getAllArcadesPlansNickname());
  arr.push(...getAllBLOPlansNickname());
  arr.push(...getAllREHPlansNickname());

  return arr;
}

export function getAllGoldPlansNickname() {
  return ['elb_gold_suite_monthly', 'elb_gold_suite', 'elb_gold_suite_gov', 'elb_platinum_suite_edu', 'elb_gold_suite_k12'];
}

export function getResellerPlansNickname() {
  return ['elb_silver_suite', 'elb_gold_suite', 'elb_platinum_suite'];
}

export function getAllMothtlyPlansNickname() {
  return ['elb_silver_suite_monthly', 'elb_gold_suite_monthly', 'elb_platinum_suite_monthly'];
}

export function getAllGovPlansNickname() {
  return ['elb_silver_suite_gov', 'elb_gold_suite_gov', 'elb_platinum_suite_gov'];
}

export function getAllEduPlansNickname() {
  return ['elb_silver_suite_edu', 'elb_gold_suite_edu', 'elb_platinum_suite_edu'];
}

export function getAllK12PlansNickname() {
  return ['elb_silver_suite_k12', 'elb_gold_suite_k12', 'elb_platinum_suite_k12'];
}

export function getAllTrialPlansNickname() {
  return ['elb_silver_suite_trial', 'elb_gold_suite_trial', 'elb_platinum_suite_trial'];
}

export function getAllSilver() {
  return ['elb_silver_suite', 'elb_silver_suite_monthly', 'elb_silver_suite_trial', 'elb_silver_suite_gov', 'elb_silver_suite_edu', 'elb_silver_suite_k12'];
}

export function getAllTTAPlansNickname() {
  return ['elb_tta_10_pack_arcade_trial', 'elb_tta_3_game_pack', 'elb_tta_10_pack', 'elb_tta_10_pack_arcade', 'elb_tta_10_pack_month'];
}

export function getAllCVRPlansNickname() {
  return ['elb_cvr_trial', 'elb_cvr_year', 'elb_cvr_month'];
}


export function getAllLOPlansNickname() {
  return ['elb_lo_trial', 'elb_lo_year', 'elb_lo_month'];
}

export function getAllALPlansNickname() {
  return ['elb_al_trial', 'elb_al_year', 'elb_al_month'];
}


export function getAllREHPlansNickname() {
  return ['elb_reh_trial', 'elb_reh_year', 'elb_reh_month'];
}

export function getAllBLOPlansNickname() {
  return ['elb_blo_trial', 'elb_blo_year', 'elb_blo_month'];
}

export function getAllArcadesPlansNickname() {
  return ['elb_arc_trial', 'elb_arc_year', 'elb_arc_month'];
}

export function getPlanNickNameFromTrial(trialNickname) {
  switch(trialNickname) {
    case 'elb_cvr_trial': return 'elb_cvr_year';
    case 'elb_gold_suite_trial': return 'elb_gold_suite';
    case 'elb_reh_trial': return 'elb_reh_year';
    case 'elb_lo_trial': return 'elb_lo_year';
    case 'elb_blo_trial': return 'elb_blo_year';
    case 'elb_tta_10_pack_arcade_trial': return 'elb_tta_10_pack';
    case 'elb_arc_trial': return 'elb_arc_year';
    case 'elb_platinum_suite_trial': return 'elb_platinum_suite';
  }

  return 'elb_gold_suite';
}
